// extracted by mini-css-extract-plugin
export default {"displayGradient":"TvDisplay_displayGradient__X7rYS","Gradient":"TvDisplay_Gradient__EexpU"};